import { Option, Select } from "@mui/joy";

import type { MaterialLineItemOption } from "../../../types";
import { ProductOptionContent, ProductSelectValue } from "./ProductOptionContent";
import { findOptionByKey, findOptionForProductId } from "../../../utils/materialColorSelection";

export type MaterialProductSelectProps = {
    products: MaterialLineItemOption[];
    /** Selected size option key, or a concrete ProductId (cart hydrate). */
    value: string | null;
    onChange?: (optionKey: string | null) => void;
    placeholder?: string;
};

export default function MaterialProductSelect({
    products,
    value,
    onChange,
    placeholder = "Select product…",
}: MaterialProductSelectProps) {
    const selected =
        findOptionByKey(products, value) || findOptionForProductId(products, value);

    return (
        <Select
            size="sm"
            placeholder={placeholder}
            value={selected?.OptionKey ?? null}
            onChange={(_, next) => onChange?.(next as string | null)}
            renderValue={() =>
                selected ? <ProductSelectValue product={selected} /> : null
            }
            slotProps={{
                listbox: {
                    sx: {
                        minWidth: 320,
                        "--ListItem-paddingY": "6px",
                    },
                },
            }}
            sx={{
                width: "100%",
                bgcolor: "background.surface",
                borderRadius: "4px",
                boxShadow: "none",
            }}
        >
            {products.map((product) => (
                <Option key={product.OptionKey} value={product.OptionKey}>
                    <ProductOptionContent product={product} />
                </Option>
            ))}
        </Select>
    );
}
